<div class="page-wrapper">
  <section>
    <div class="content-wrapper">
      <section class="login-register-page">
        <p class="form-errors reg-error" *ngIf="isError">
          {{ errorMessage }}
        </p>

        <div class="social-wrapper">
          <h2>{{ pageData.social_heading }}</h2>
          <app-social-login-buttons
            [isUnihomesDeeplink]="isUnihomeProduct"
            [universityUUID]="universityUUID"
            [accommodationUUID]="accommodationUUID"
          ></app-social-login-buttons>
        </div>

        <div class="login-wrapper">
          <h2>{{ pageData.email_heading }}<br /><br /></h2>

          <a
            [routerLink]="'/register'"
            (click)="emailButtonClicked()"
            class="email-login-button"
          >
            <button class="button">
              Email&nbsp;address&nbsp;&amp;&nbsp;password
            </button>
          </a>
          <a
            *ngIf="!isUnihomeProduct"
            [routerLink]="'/'"
            class="already-have-account"
          >
            {{ pageData.login_link_text }}
          </a>
        </div>
      </section>
    </div>
  </section>
</div>
